import CourseProgress from 'pages/open-course/common/models/courseProgress';

import CatalogCollection from 'bundles/catalogP/models/catalogCollection';

const CourseProgressCollection = CatalogCollection.extend({
  model: CourseProgress,
  resourceName: 'onDemandCoursesProgress.v1',
});

export default CourseProgressCollection;
